import { FC } from 'react'

export const TermsPage: FC = () => {
  return (
    <h1>Terms</h1>
  )
}
